import Markdown from 'react-markdown';

type Props = { content: string };

const MarkDownComp = ({ content }: Props) => {
  return (
    <div className='markdown'>
      <Markdown>{content}</Markdown>
    </div>
  );
};

export default MarkDownComp;
